/**
 * Typed selectors for the `auth_status` domain (Phase A.3).
 * Replaces the 30s polls on /api/auth/status from TopBar, AuthSetup,
 * StrategyBuilder.
 */
import { useStateStore } from "@/state/store";

export interface KiteToken {
  authenticated:    boolean;
  hours_remaining:  number | null;
  expires_at:       string | null;
  auth_time:        string | null;
}

export interface MctSession {
  google_configured:  boolean;
  allowed_email_set:  boolean;
  max_session_secs:   number;
}

export interface AuthStatusSnapshot {
  as_of:                string;
  kite_authenticated:   boolean;
  kite_token:           KiteToken;
  mct_session:          MctSession;
  _seq?:                number;
}

export function useAuthStatus(): AuthStatusSnapshot | null {
  return useStateStore((s) => s.auth_status.snapshot as AuthStatusSnapshot | null);
}

export function useKiteAuthenticated(): boolean {
  return useStateStore((s) => {
    const snap = s.auth_status.snapshot as AuthStatusSnapshot | null;
    return snap?.kite_authenticated ?? false;
  });
}

export function useKiteToken(): KiteToken | null {
  return useStateStore((s) => {
    const snap = s.auth_status.snapshot as AuthStatusSnapshot | null;
    return snap?.kite_token ?? null;
  });
}

export function useAuthIsStale(): boolean {
  return useStateStore((s) => s.auth_status.isStale);
}
